import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow

// No rewarded ad inventory on web; the Plus Pass offer stays hidden.
actual object BankoRewardedAd {
    actual val isSupported: Boolean = false
    actual val isReady: StateFlow<Boolean> = MutableStateFlow(false)

    actual fun preload() {}

    actual fun show(onResult: (rewarded: Boolean) -> Unit) {
        onResult(false)
    }
}
